import React, { useState, useEffect, SyntheticEvent } from 'react';
import { Form, Grid, Modal, Image } from 'semantic-ui-react';
import { FormikProps } from 'formik';
import { FormValues } from './types';
import { LoginProps } from './Login';
import Input from '../../components/Input';
import Button from '../../components/Button';
import backgroundrv from '../../resources/imgs/banner-login-lado-bom-seguros.png';
import Loader from '../../components/Loader';
import logorv from '../../resources/imgs/logo-lado-bom-seguros.svg';
import comunicacao_login from '../../resources/imgs/comunicacao-login-rv.png';
import { FormikErrorMessage } from '../../components/ErrorMessage';
import {
  Pushable,
  SideBarGrid,
  Logo,
  FormContainer,
  WelcomeText,
  Pusher,
  ImageBackground,
  Confiax
} from './styles';
import { FieldLabel } from '../../styles';
import { getAll, get, set, remove } from '../../services/storage';

const LoginForm = (props: LoginProps & FormikProps<FormValues>) => {
  const {
    values,
    handleSubmit,
    handleChange,
    isSubmitting,
    isInternalLogin,
    hasEmail,
    hasPassword,
    setFieldValue
  } = props;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [hasRead, setHasRead] = useState<boolean>(false);

  const readLogin = async () => {
    setHasRead(true);
    setOpenModal(false);
    set('hasRead', 'true');
  };

  const getRead = async () => {
    const hasRead = get('hasRead');
    setHasRead(hasRead === 'true');
    const keys = Object.keys(getAll());
    keys.forEach(key => {
      if (key !== 'hasUpdatedEmails') {
        remove(key);
      }
    });
  };

  useEffect(() => {
    getRead();
    if (hasEmail) {
      setFieldValue('email', hasEmail);
    }
  }, []);

  if (isSubmitting) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <>
      <Pushable>
        <SideBarGrid>
          <Logo src={logorv} />
          <FormContainer>
            <div>
              <WelcomeText>
                Olá, seja <br /> bem-vindo!
              </WelcomeText>

              {/* {!isInternalLogin && (
                <InfoText>
                  <Icon name="attention" size="large" />
                  Nossa forma de login mudou.{' '}
                  <a
                    onClick={() => {
                      setOpenModal(true);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    Clique aqui e saiba mais!
                  </a>
                </InfoText>
              )} */}
              <Form initialValues={values} onSubmit={handleSubmit}>
                <FieldLabel>E-MAIL:</FieldLabel>
                <Input
                  name="email"
                  type="email"
                  icon={{ name: 'users', color: 'blue' }}
                  iconPosition="left"
                  fluid
                  onChange={handleChange}
                  value={values.email}
                />
                <FormikErrorMessage component="div" name="email" />
                <p />
                {isInternalLogin && hasPassword && (
                  <>
                    <FieldLabel>SENHA:</FieldLabel>
                    <Input
                      name="password"
                      type="password"
                      icon={{ name: 'lock', color: 'blue' }}
                      iconPosition="left"
                      fluid
                      onChange={handleChange}
                      value={values.password}
                    />
                    <FormikErrorMessage component="div" name="password" />
                    <p />
                    <Grid columns={2}>
                      <Grid.Row>
                        <Grid.Column>
                          <a
                            href="/recovery-password"
                            onClick={(e: SyntheticEvent) => {
                              props.history.push('/recovery-password');
                            }}
                          >
                            Esqueci minha senha
                          </a>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </>
                )}
                {isInternalLogin && !hasPassword && (
                  <p style={{ color: 'green' }}>
                    <b>
                      Um link para criação de uma nova senha foi enviado para o e-mail
                      informado
                    </b>
                  </p>
                )}
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      {isInternalLogin ? (
                        <Button
                          text="Fazer login"
                          color="green"
                          size="large"
                          type="submit"
                        />
                      ) : (
                        <Button
                          text="Verificar e-mail"
                          color="green"
                          size="large"
                          type="submit"
                        />
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {!isInternalLogin && (
                    <Grid.Row>
                      <Grid.Column textAlign="center" width={16}>
                        Ainda não é cliente?{' '}
                        <a
                          href="https://conteudo.somosgruporv.com.br/solucoes-gruporv?redirectApp=redeConfiax"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Clique aqui
                        </a>
                      </Grid.Column>
                    </Grid.Row>
                  )}
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      <Confiax></Confiax>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      <Confiax></Confiax>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            </div>
          </FormContainer>
        </SideBarGrid>
        <Pusher>
          <ImageBackground src={backgroundrv} />
        </Pusher>
      </Pushable>

      <Modal open={openModal} size={'large'}>
        <Modal.Header>Modal de Instrução - Novo Login</Modal.Header>
        <Modal.Content scrolling={hasRead} image>
          <Image src={comunicacao_login} wrapped />
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={readLogin} content={'Estou ciente, Prosseguir!'} />
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default LoginForm;
